<script lang="ts">
	import classNames from 'classnames';
	import { page } from '$app/stores';
	import { useFormInfo } from '$lib/form-info/form-info';

	const { formInfo } = useFormInfo();

	let stages: string[] = [];

	$: if ($formInfo && $formInfo.type) {
		if ($formInfo.type == 'Club') {
			stages = ['Parent/Guardian Info', 'Child Information', 'Confirm Registration'];
		} else {
			stages = [
				'Parent/Guardian Info',
				'Child Information',
				'Day / Time Preferences',
				'Confirm Registration'
			];
		}
	}

	let selectedStage: string = 'About/Guardian Info';

	$: if ($page.url.pathname) {
		if ($page.url.pathname.includes('registration')) {
			selectedStage = 'About/Guardian Info';
		} else if ($page.url.pathname.includes('students')) {
			selectedStage = 'Child Information';
		} else if ($page.url.pathname.includes('preferences')) {
			selectedStage = 'Day / Time Preferences';
		} else if ($page.url.pathname.includes('confirm')) {
			selectedStage = 'Confirm Registration';
		}
	}
</script>

<div class="form-header">
	<div class="flex flex-wrap gap-2">
		{#each stages as stage, index}
			<div class="flex items-center gap-2">
				<p
					class={classNames(
						`text-sm text-shark font-poppins-regular pt-[3px]`,
						selectedStage === stage && ' !text-affair !font-poppins-semi-bold'
					)}
				>
					{stage}
				</p>
				{#if stages.length !== index + 1}
					<div>
						<span>{'>'}</span>
					</div>
				{/if}
			</div>
		{/each}
	</div>
</div>
